export const api = {
  violation: {
    queryViolationRecordList: '/bms/violation/queryViolationRecordList.json', // 查询罚单列表接口
    updateViolationRecord:'/bms/violation/updateViolationRecord.json', // 修改罚单
    queryPersonnelVehicleList:'/vas/personnel/queryPersonnelVehicleList.json', // 查询人员列表
  }
}
